const styleSheet = () => ({
  submissionError: {
    padding: '15px 24px',
    textAlign: 'right',
    overflowWrap: 'break-word',
    opacity: 0,
    whiteSpace: 'pre-wrap',
  },
  text: {
    color: '#d0021b',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '18px',
    fontFamily: 'CircularStd, sans-serif',
  },
});

export default styleSheet;
